define.alias("ember-cli-string-helpers/utils/titleize", "settings/utils/titleize");